import React from 'react';
import logo from '../../../assets/images/splashLogo.png';
export default function SplashScreen() {
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        marginTop: -8,
        marginRight: -8,
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(to bottom, #30abfd, #103955)',
      }}
      className="splash-screen"
    >
      <div className="splash-screen__logo">
        <img
          style={{width: '193.94515991210938px', height: '160px'}}
          src={logo}
          alt="Logo"
        />
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: '52px',
          left: '50%',
          transform: 'translateX(-50%)',
          fontWeight: 'lighter',
          fontSize: '16px',
          lineHeight: '29px',
          color: '#ffffff',
          height: '29px',
        }}
      >
        V2.12.3
      </div>
    </div>
  );
}
